export default __webpack_public_path__ + "static/B0141-08f32ca91c651f23cbb8a77c1b00aa5c.png";